import moment from "moment";
import documentIcon from "../../assets/icons/document.svg";
import priorityIcon from "../../assets/icons/ticket-priority.svg";
import locationIcon from "../../assets/icons/location.svg";
import calendarIcon from "../../assets/icons/calendar.svg";
import groupIcon from "../../assets/icons/group.svg";
import infoIcon from "../../assets/icons/info.svg";
import hookupMarkerIcon from "../../assets/icons/hookup.svg";
import { ticketPriorityHelper } from "./ticketDetailsHelper";
import { Marker } from "../../components/Map/Artifacts";
import { prepareIncomingCoordinates } from "./formatters";
import L from "leaflet";
// TODO: Decouple markers from clusters with a Marker component
// Refactoring TBD Layer > Clusters > Markers > Popup > Details


export const ticketMarker = (ticket, L) => {
  const workdate = new Date(parseInt(ticket.pge_work_date)).toISOString();
  const formattedWorkdate = moment(workdate).format("MM/DD/YYYY HH:mm");
  const ticketPriority = ticketPriorityHelper(ticket.priority);
  const latlonCoordinates = prepareIncomingCoordinates(
    ticket.pge_center_coords.coordinates
  );
  const ticketAttachments = {
    priority: ticket.priority,
    fmCheck: ticket.fieldMeets && ticket.fieldMeets?.length !== 0,
    sbCheck: ticket.standbys && ticket.standbys?.length !== 0,
  };
  
  // Add mapsearch prefix when in local env mode
  const localEnvPrefix = process.env.REACT_APP_LOCAL_ENV === 'true' ? 'mapsearch/' : '';
  const getIconPath = (icon) => localEnvPrefix + icon;
  
  const sbAttachment = ticketAttachments.sbCheck
    ? `<span class="att-tag att-tag-sb">SB</span>`
    : ``;
  const fmAttachment = ticketAttachments.fmCheck
    ? `<span class="att-tag att-tag-fm">FM</span>`
    : ``;
  const p = L.popup().setContent(`
        <div class="marker-popup-content">
            <h3>${ticket.id}</h3>
            <dl>
                <dt title="Status"><img src=${getIconPath(documentIcon)} alt="Status" /></dt>
                <dd title="Status">${ticket.pge_status}</dd>
                <dt title="Priority"><img src=${getIconPath(priorityIcon)} alt="Priority" /></dt>
                <dd title="Priority">${ticketPriority} ${sbAttachment} ${fmAttachment}</dd>
                <dt title="Location"><img src=${getIconPath(locationIcon)} alt="Location" /></dt>
                <dd title="Location">${ticket.pge_address}</dd>
                <dt title="Work Date"><img src=${getIconPath(calendarIcon)} alt="Work Date" /></dt>
                <dd title="Work Date">${formattedWorkdate}</dd>
                <dt title="Excavator"><img src=${getIconPath(groupIcon)} alt="Excavator" /></dt>
                <dd title="Excavator">${ticket.pge_excavator}</dd>
                <dt title="Work Type"><img src=${getIconPath(infoIcon)} alt="Work Type" /></dt>
                <dd title="Work Type">${ticket.work_type}</dd>
                <dt class="hide-me"></dt>
                <dd class="popup-link">
                <strong><a href="/ticketDetails/${ticket.id}" target="_blank" rel="noopener noreferrer" title="Open full ticket details in a new tab">
                    See More Ticket Details
                </a></strong>
                </dd>
            </dl>
        </div>`);

  const marker = L.marker(latlonCoordinates, {
    icon: Marker("TICKET", ticketAttachments),
    ticketID: ticket.id,
    priority: ticket.priority,
    pge_status: ticket.pge_status,
    //pge_polygon: ticket.pge_polygon.coordinates
  }).bindPopup(p); // Move to Artifacts/Popup.js
  return marker;
};

export const getVisibleTickets = (map, targetLayer, tickets) => {
  let bounds = map.getBounds();
  let visibleTicketIds = [];

  const clusterLayer = targetLayer.getLayers();

  clusterLayer.length > 0 &&
    clusterLayer[0].eachLayer((marker) => {
      if (bounds.contains(marker._latlng)) {
        visibleTicketIds.push(marker.options.ticketID);
      }
    });
  const matchedTickets = matchTicketsToMarkers(tickets, visibleTicketIds);
  return matchedTickets;
};

const matchTicketsToMarkers = (tickets, visibleTicketIds) => {
  // compare in-bounds IDs with searched ticketData to sync results table data with viewport
  const matchingIds = tickets.filter(
    (item) => visibleTicketIds.indexOf(item.id) !== -1
  );
  return matchingIds;
};
const createTicketClusters = (tickets) => {
  const ticketMarkers = createMarkersForCluster(tickets);
  const clusterMarkers = L.markerClusterGroup({
    maxClusterRadius: 160,
    chunkedLoading: true,
    iconCreateFunction: function (cluster) {
      const markers = cluster.getAllChildMarkers();
      const allPrioritiesEqual = markers.every((marker) => {
        return marker.options.priority === markers[0].options.priority;
      });
      let clusterClasses = "cluster cluster";
      const clusterCount = cluster.getChildCount();
      clusterClasses +=
        allPrioritiesEqual && markers[0].options.priority === "EMER"
          ? "-emergency"
          : "-default";

      clusterClasses += " marker-cluster";
      clusterClasses += clusterCount < 100 ? "-small" : "";
      clusterClasses +=
        clusterCount > 99 && clusterCount < 1000 ? "-medium" : "";
      clusterClasses += clusterCount > 999 ? "-large" : "";

      return L.divIcon({
        html: `<div><span>${clusterCount}</span></div>`,
        className: clusterClasses,
      });
    },
  });
  clusterMarkers.addLayers(ticketMarkers);
  return clusterMarkers;
};
const createMarkersForCluster = (tickets) => {
  let ticketMarkerList = [];
  tickets.forEach((ticket) => {
    if (ticket.pge_center_coords) {
      ticketMarkerList.push(ticketMarker(ticket, L));
    }
  });
  return L.layerGroup(ticketMarkerList);
};
export const findLayer = (map, targetLayer) => {
  let foundLayer;
  map.eachLayer((layer) => {
    if (layer.id === targetLayer) {
      foundLayer = layer;
    }
  });
  return foundLayer;
};
export const clearLayer = (targetLayer) => {
  targetLayer.clearLayers();
};

export const addMarkersToLayer = (markers, targetLayer) => {
  markers.addTo(targetLayer);
};

export const createLayerMarkers = (tickets, targetLayer) => {
  switch (targetLayer.id) {
    case "TICKET_CLUSTER_MARKERS":
      return createTicketClusters(tickets);
    default:
      return null;
  }
};

export const initializeLayers = (map) => {
  const definedLayers = [
    "EMERGENCY_CLUSTER_MARKERS",
    "TICKET_CLUSTER_MARKERS",
    "INPUT_SEARCH_MARKER",
    "USER_LOCATION_MARKER",
    "DRAWN_POLYGON"
  ];

  definedLayers.forEach((layer) => {
    const newLayer = L.layerGroup([]);
    newLayer.id = layer;
    map.target.addLayer(newLayer);
  });
};


export const hookupMarker = (hookupName, workLogId, hookupCoordinates, index) => {
  const marker = L.marker(hookupCoordinates, {
    id: `${hookupName}-${workLogId}`,
    icon: new L.divIcon({
      className: 'hookup-icon',
      html: `<img src=${hookupMarkerIcon}><span>${index + 1}</span></img>`,
  })
})
  return marker;
};
